import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_SYSTEM_SOFTWARE} from '../../metamodel/Concept';

export default class SystemSoftwareNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_SYSTEM_SOFTWARE;
	}
}
